import { HomeComponentProps, HomeComponentState, HomeComponentHandler } from './homecomponent';
import { HomeCSSStyle } from './homecss';
import { UIComponentHandler } from '../../../toolkit/uicomponent';
import * as React from 'react';
import { FeaturedCategoryDto } from '../../../../core/dto/featuredcategory/featuredcategorydto';
import { BaseContext } from '../../../../utils/basecontext';
import { CRBTUIViewImpl } from '../crbt/crbtuiview';
import { BannerComponent } from '../banner/bannercomponent';
import { BannerDto } from '../../../../core/dto/banner/bannerdto';
import { Strings } from '../../../../utils/resources/strings';
import { FeaturedCategoryComponent } from '../featuredcategory/featuredcomponent';
import { SearchBoxComponent } from '../../../toolkit/toolbarwithsearch/searchbox/searchboxcomponent';
import { SearchBoxCSSStyle, SearchBoxCSSStyleImpl } from '../../../toolkit/toolbarwithsearch/searchbox/searchboxcss';
import { SearchBoxToneOptionComponent } from '../../../toolkit/toolbarwithsearch/searchbox/searchboxtoneoption/searchboxtoneoptioncomponent';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';
import './home-style.css';
import '../crbt/crbt-style.css';
import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { MSISDNValidationComponent } from '../../popup/msisdnvalidation/msisdnvalidationcomponent';
import { AlertComponent } from '../../../toolkit/alert/alertcomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { OTPVerificationComponent } from '../../popup/otpverification/otpverificationcomponent';
import { UpgradePackComponent } from '../../popup/upgrade_pack/upgradepackcomponent';
import { ToneDto, ToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/tonedto';

import { FlashComponent } from '../../popup/flashpopup/flashcomponent';
import { FlashPopUpWrapperComponent } from '../../popup/flashpopup/flashwrapper/flashpopupwrappercomponent';
import { RoutingFeatures } from '../../navigation/routingfeature';
import { ProfiletunesCategoryComponent } from '../profiletunes/profiletunescomponent';

export class HomeViewImpl extends CRBTUIViewImpl {
    private searchCSSStyle: SearchBoxCSSStyle;
    private popupComponent: PopUpWrapperComponent;
    private flashPopupComponent: PopUpWrapperComponent;
    // private featuredCategroiesRefMap: Map<string, FeaturedCategoryListComponent>;
    constructor(context: BaseContext, uiComponentHandler: UIComponentHandler) {
        super(context, uiComponentHandler);
        this.searchCSSStyle = new SearchBoxCSSStyleImpl(context);
    }

    bindHandlers() {
        this.onBannerClick = this.onBannerClick.bind(this);
        // this.onCategorySelected = this.onCategorySelected.bind(this);
        this.onLoadMore = this.onLoadMore.bind(this);
        this.onSearchButtonClick = this.onSearchButtonClick.bind(this);
        this.onSpecificSearchClick = this.onSpecificSearchClick.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.showToneOptionsPopup = this.showToneOptionsPopup.bind(this);
        this.onTryAgainClick = this.onTryAgainClick.bind(this);
        this.setNowClick = this.setNowClick.bind(this);
    }

    // draw(props: HomeComponentProps, state: HomeComponentState, cssStyle: HomeCSSStyle): JSX.Element | boolean
    // {
    //     super.draw(props, state, cssStyle);

    //     return (
    //         <div style={cssStyle.getWrapperCSSStyle()}>
    //               {
    //                    state.listOfFeaturedCategories.map((featuredCategoryDto: FeaturedCategoryDto, index: number) =>
    //                    {
    //                       return <FeaturedCategoryListComponent  ref={(item: FeaturedCategoryListComponent) => {this.featuredCategroiesRefMap.set(featuredCategoryDto.getTitle(), item);}} onLoadMore={this.onLoadMore}  key={index} featuredCategory={featuredCategoryDto}   context={props.context}/>;
    //                    })
    //               }
    //               {
    //                   state.listOfCategories.length > 0 && 
    //                    <CategoriesComponent   onCategorySelected={this.onCategorySelected}   listOfDatas={state.listOfCategories}  context={props.context}/>
    //               }
    //         </div>
    //     );
    // }

    draw(props: HomeComponentProps, state: HomeComponentState, cssStyle: HomeCSSStyle): JSX.Element | boolean {
        super.draw(props, state, cssStyle);

        return (
            <>

                <div id="home-wrapper">
                    {
                        this.getWebView(props, state, cssStyle)
                    }
                </div>
                <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={props.context} />
                <FlashPopUpWrapperComponent ref={(item: any) => this.flashPopupComponent = item} context={props.context} />

            </>);
    }

    getWebView(props: HomeComponentProps, state: HomeComponentState, cssStyle: HomeCSSStyle): JSX.Element {
        return (
            <>
                {/* <img  style={cssStyle.getLogoCSSStyle()} src={this.getUIProps().context.getResources().getImage(".svg")}/> */}
                <>
                    <div id="mpt-banner-web">
                        {
                            state.isConfiguartionLoaded && this.getMPTBannerWeb(cssStyle)
                        }
                    </div>
                    <div id="mpt-banner-mobile">
                        {
                            state.isConfiguartionLoaded && this.getMPTBannerMobile(cssStyle)
                        }
                    </div>
                </>
                {
                    state.isConfiguartionLoaded && state.listOfBannerDtos.length > 0 &&
                    <BannerComponent onBannerClick={this.onBannerClick} listOfBannerDto={state.listOfBannerDtos} context={props.context} />
                }
                <div id="home-search-main" style={{ backgroundImage: "url('" + this.getContext().getResources().getImage("search_bg.svg") + "')", }}>
                    <div id="home-search-div" style={{}}>

                        <SearchBoxToneOptionComponent type={props.context.getResources().getString(Strings.song)} context={this.getContext()} searchKey={""} onSearchBoxButtonClicked={this.onSpecificSearchClick} />
                    </div>
                </div>
                {state.isConfiguartionLoaded &&
                    <div id="crbt-home-inner-wrapper" style={cssStyle.getInnerCSSStyle()}>
                        <FeaturedCategoryComponent context={props.context} />
                    </div>
                }
                {state.isConfiguartionLoaded &&
                    <div id="home-status-tunes-wrapper" style={{ marginBottom: "100px" }}>
                        <ProfiletunesCategoryComponent context={props.context} />
                    </div>
                }



                {/* <div id="home-search-box-wrapper" style={{width:'100%', height:'300px',marginTop:'25px',display: "flex", flexFlow: "row wrap",backgroundImage: "url('" + this.getContext().getResources().getImage("nametunes.jpg") + "')",backgroundSize: "cover",}}>
                           
                           <label id="home-search-greet-label" style={{width:'100%',paddingLeft:'75px',paddingTop:'80px', height:'30px', lineHeight:'30px',fontSize:'40px',color:'#FFCD00',textAlign:'left'}}>
                               {this.getContext().getResources().getString(Strings.greet_caller_with_your_name_tunes)}
                           </label>
                           <div id="search-box-main-div" style={{marginTop:'0px',width:'60%',height:'50px',marginLeft:'75px', paddingBottom: '50px'}}>
                               <SearchBoxComponent  cssStyle={this.searchCSSStyle} searchKey={''} onSearchBoxButtonClicked={this.onSearchButtonClick} context={props.context}/>
                           </div>
                       </div>     */}
                <>
                    <div id="home-nametune-web">
                        {
                            this.getWebNameTune(state, props)
                        }
                    </div>
                    <div id="home-nametune-mobile">
                        {
                            this.getMobileNameTune(state, props)
                        }
                    </div>
                </>

            </>
        );
    }

    getMobileNameTune(state: HomeComponentState, props: HomeComponentProps): JSX.Element {
        return (
            <>
                <div id={this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? "home-nametune-english" : "home-nametune-burmese"} style={{ width: '100%', height: '140px', justifyContent: "center", marginTop: '0px', display: "flex", flexFlow: "row wrap", backgroundColor: this.getContext().getResources().getColor(Colors.color_36), backgroundSize: "cover", }}>

                    <label style={{ width: '100%', paddingLeft: '0px', paddingTop: '30px', height: '30px', lineHeight: '22px', fontSize: '16px', color: this.getContext().getResources().getColor(Colors.color_5), textAlign: 'center' }}>
                        {this.getContext().getResources().getString(Strings.greet_caller_with_your_name_tunes)}
                    </label>
                    <div style={{ marginTop: '0px', width: '80%', height: '40px', marginLeft: '0px', paddingBottom: '30px' }}>
                        <SearchBoxComponent cssStyle={this.searchCSSStyle} searchKey={''} onSearchBoxButtonClicked={this.onSearchButtonClick} context={props.context} />
                    </div>
                </div>
                {/* <div id={this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH?"home-subscription-details-english":"home-subscription-details-burmese"} style={{width:'100%', height:'auto',flexFlow: "row wrap"}}> */}
                {/* <div style={{width:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '100%' : "100%",height:'18px',fontWeight:'bold',marginLeft:'26px',marginRight: "0px", marginBottom:'20px', fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '16px' : "14px",textAlign:'left',color:'#000000'}}>
                                       {state.subscriptionPlanDetailsDto.getTitle()}
                              </div>
                              <div style={{width:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '100%' : "100%",height:'95px',marginLeft:'3px',marginBottom:'30px', fontSize:'14px',textAlign:'left',color:'#000000'}}>
                              <ul> 
                                { state.subscriptionPlanDetailsDto.getDescriptionList().map((data: string, index: number) =>
                                   {
                                       return <li  style={{width:'100%',lineHeight:'20px',letterSpacing:"-0.2px", fontSize:'13px',textAlign:'left'}} key={index}>{data}</li>;
                                   })
                                }
                                    
                              </ul>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Caller will listen to a musical ring back tone that you sent."}</li>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Monthly subscription fee 300 Kyats"}</li>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Subscription will be auto renewed after 30 days. "}</li>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Tune price is 100 Kyats and each Tune is valid for 30 days. "}</li>
                                       </ul>
                              </div> */}
                <div style={{ display: "inline" }}>
                    {this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? <img style={{ height: "auto", width: "100%", display: "flex", flexFlow: "row wrap" }} src={this.getUIProps().context.getResources().getImage("express_yourself_mobile.svg")} />
                        : <img style={{ height: "auto", width: "100%", display: "flex", flexFlow: "row wrap" }} src={this.getUIProps().context.getResources().getImage("express_yourself_burmese_mobile.svg")} />}
                    {/* <div style={{width:"100%",paddingTop:"30px",height:"auto",flexFlow: "row wrap",backgroundImage: "url('" + this.getContext().getResources().getImage("express_yourself_mobile.svg") + "')",backgroundSize: "cover"}}/> */}
                </div>
            </>
        );
    }
    getWebNameTune(state: HomeComponentState, props: HomeComponentProps): JSX.Element {
        return (
            <>
                <div style={{ width: "100%", height: "auto", display: "inline", flexFlow: "row wrap" }}>


                    <div style={{ width: '100%', height: '300px', display: "flex", flexFlow: "row wrap", backgroundColor: this.getContext().getResources().getColor(Colors.color_36), backgroundSize: "cover", }}>
                        {/* ,backgroundImage: "url('" + this.getContext().getResources().getImage("nametunes.jpg") + "')", */}
                        <label style={{ width: '100%', paddingLeft: '75px', paddingTop: '80px', height: '30px', lineHeight: '30px', fontSize: '40px', color: this.getContext().getResources().getColor(Colors.color_5), textAlign: 'left' }}>
                            {this.getContext().getResources().getString(Strings.greet_caller_with_your_name_tunes)}
                        </label>
                        <div id="search-box-main-div" style={{ marginTop: '0px', width: '60%', height: '50px', marginLeft: '75px', paddingBottom: '50px' }}>
                            <SearchBoxComponent cssStyle={this.searchCSSStyle} searchKey={''} onSearchBoxButtonClicked={this.onSearchButtonClick} context={props.context} />
                        </div>
                    </div>
                    {/* <div style={{width:'100%',paddingTop:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '74px' : "94px", height:'350px',flexFlow: "row wrap",backgroundImage: "url('" + this.getContext().getResources().getImage("expressyourself.jpg") + "')",backgroundSize: "cover"}}>
                              <div style={{width:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '603px' : "755px",height:'55px',fontWeight:'bold',marginLeft:'auto',marginRight: "70px", marginBottom:'15px', fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '40px' : "35px",textAlign:'left',color:'#000000'}}>
                                       {state.subscriptionPlanDetailsDto.getTitle()}
                              </div>
                              <div style={{width:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '690px' : "840px",height:'132px',marginLeft:'auto',marginBottom:'74px', fontSize:'40px',textAlign:'left',color:'#000000'}}>
                              <ul> 
                                { state.subscriptionPlanDetailsDto.getDescriptionList().map((data: string, index: number) =>
                                   {
                                       return <li  style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}} key={index}>{data}</li>;
                                   })
                                }
                                    
                              </ul>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Caller will listen to a musical ring back tone that you sent."}</li>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Monthly subscription fee 300 Kyats"}</li>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Subscription will be auto renewed after 30 days. "}</li>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Tune price is 100 Kyats and each Tune is valid for 30 days. "}</li>
                                       </ul>
                              </div>
                       </div>   */}


                    <div style={{ display: "inline" }}>
                        {this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?
                            <img style={{ height: "auto", width: "100%", display: "flex", flexFlow: "row wrap" }} src={this.getUIProps().context.getResources().getImage("express_yourself_updated.svg")} />
                            : <img style={{ height: "auto", width: "100%", display: "flex", flexFlow: "row wrap" }} src={this.getUIProps().context.getResources().getImage("express_yourself_burmese_updated.svg")} />
                        }

                        {/* {this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?
                                <div id="express-yourself-background" style={{width:'100%',paddingTop:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '74px' : "94px",flexFlow: "row wrap",backgroundImage: "url('" + this.getContext().getResources().getImage("expressyourself_updated.svg") + "')",backgroundSize: "cover"}}/>
                                    :<div id="express-yourself-background" style={{width:'100%',paddingTop:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '74px' : "94px",flexFlow: "row wrap",backgroundImage: "url('" + this.getContext().getResources().getImage("express_yourself_burmese.svg") + "')",backgroundSize: "cover"}}/>} */}
                    </div>
                </div>

            </>
        );
    }
    getMPTBannerMobile(cssStyle: HomeCSSStyle): JSX.Element {
        let configurationDto = this.getUIProps().context.getConfigurationSettings().getConfigurationSettings("TOP_BANNER_CLICK");
        let url = configurationDto.getEnable() ? configurationDto.getAttribute() : "javascript:void(0);";
        return (
            <>
                {this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?
                    <a href={url}><img style={cssStyle.getMobileLogoCSSStyle()} src={this.getUIProps().context.getResources().getImage("mpt_banner_mobile.svg")} /></a>
                    : <a href={url}><img style={cssStyle.getMobileLogoCSSStyle()} src={this.getUIProps().context.getResources().getImage("mpt_banner_burmese_mobile.svg")} /></a>}
            </>
        );
    }
    getMPTBannerWeb(cssStyle: HomeCSSStyle): JSX.Element {
        let configurationDto = this.getUIProps().context.getConfigurationSettings().getConfigurationSettings("TOP_BANNER_CLICK");
        let url = configurationDto.getEnable() ? configurationDto.getAttribute() : "javascript:void(0);";

        return (
            <>
                {this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?
                    <a href={url}><img style={cssStyle.getLogoCSSStyle()} src={this.getUIProps().context.getResources().getImage("mpt_banner.svg")} /></a>
                    : <a href={url}><img style={cssStyle.getMobileLogoCSSStyle()} src={this.getUIProps().context.getResources().getImage("mpt_banner_burmese.svg")} /></a>}
            </>
        );
    }

    onSpecificSearchClick(searchKey: string, type: string): void {
        searchKey = searchKey.trim();
        (this.getUIComponentHandler() as HomeComponentHandler).onSpecificSearchClick(searchKey, type);

    }
    onSearchButtonClick(searchKey: string): void {
        searchKey = searchKey.trim();
        (this.getUIComponentHandler() as HomeComponentHandler).onSearchClick(searchKey);
    }

    setNowClick() {
        (this.getUIProps() as HomeComponentProps).routeNextFeature(RoutingFeatures.FLASH_MESSAGE, false);
    }
    showEAUCPackPromotion() {
        // console.log("Pack $$$$$$$$$$$$$$$$$$$$$$",this.getUIProps().context.getUserContext().getEAUCPackEnabled(this.getUIProps().context.getUserContext().getLanguage()));
        if (this.getUIProps().context.getUserContext().getLanguage() === LanguageConst.ENGLISH) {
            if (!this.getUIProps().context.getUserContext().getEAUCEnglishPackEnabled() &&
                !this.getUIProps().context.getUserContext().getIsLoggedIn()) {
                this.flashPopupComponent !== null && this.flashPopupComponent.setShowWindow(true,
                    <FlashComponent showToneOptionsPopup={this.showToneOptionsPopup} closePopup={this.closePopup} id={""} packTitle={"EAUC"} context={this.getContext()} />);
            }

        }

        else if (!this.getUIProps().context.getUserContext().getEAUCBurmesePackEnabled() &&
            !this.getUIProps().context.getUserContext().getIsLoggedIn()) {
            this.flashPopupComponent !== null && this.flashPopupComponent.setShowWindow(true,
                <FlashComponent showToneOptionsPopup={this.showToneOptionsPopup} closePopup={this.closePopup} id={""} packTitle={"EAUC"} context={this.getContext()} />);
        }


    }

    getNavigationPath(): string[] {
        return [this.getUIProps().context.getResources().getString(Strings.home)];
    }


    protected closePopup() {
        this.popupComponent !== null && this.popupComponent.setShowWindow(false, <></>);
        this.flashPopupComponent !== null && this.flashPopupComponent.setShowWindow(false, <></>);
    }

    showToneOptionsPopup(id: string): void {
        this.closePopup();
        if (id === this.getUIProps().context.getResources().getString(Strings.buy_now) + "_" +
            this.getUIProps().context.getResources().getString(Strings.upgradePack)) {
            this.popupComponent !== null && this.popupComponent.setShowWindow(true,
                <UpgradePackComponent id={this.getUIProps().context.getResources().getString(Strings.buy_now)} toneDto={this.getEUACToneDto()} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context} />);

        }
        else if (id === this.getUIProps().context.getResources().getString(Strings.buy_now) + "_" +
            this.getUIProps().context.getResources().getString(Strings.upgradePack) + "_" +
            this.getUIProps().context.getResources().getString(Strings.otp_verification)) {
            this.popupComponent !== null && this.popupComponent.setShowWindow(true,
                <OTPVerificationComponent toneDto={this.getEUACToneDto()} id={this.getUIProps().context.getResources().getString(Strings.upgradePack)} showOptionsPopup={this.showToneOptionsPopup} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context} />);

        }
        else if (id === this.getUIProps().context.getResources().getString(Strings.msisdn_validation)) {
            this.popupComponent !== null && this.popupComponent.setShowWindow(true,
                <MSISDNValidationComponent toneDto={this.getEUACToneDto()} showPopupOption={this.showToneOptionsPopup} showPopup={this.showPopup} headerTitle={this.getContext().getResources().getString(Strings.verify_yourself)} closePopup={this.closePopup} context={this.getUIProps().context} />);
        }
    }


    showPopup(id: string, msg: string, type: AlertType): void {
        this.closePopup();
        if (type === AlertType.WARN) {
            this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.tryagain)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={(e) => this.onTryAgainClick(id)} context={this.getUIProps().context} />);
        }
        else {
            this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context} />);
        }
    }

    onTryAgainClick(id: string): void {
        this.closePopup();
        this.showToneOptionsPopup(id);
    }

    getEUACToneDto(): ToneDto {
        let toneDto = new ToneDtoImpl();
        // toneDto.setId("0006946205");
        let defaultTone = this.getContext().getConfigurationSettings().getPropertyBasedOnLanguage("DEFAULT_TONE").split("|");
        toneDto.setId(defaultTone[0]);
        toneDto.setToneName(defaultTone[1]);

        return toneDto;
    }
    private onBannerClick(bannerDto: BannerDto) {
        (this.getUIProps() as HomeComponentProps).onBannerClick(bannerDto);
    }

    private onLoadMore(featuredCategory: FeaturedCategoryDto, startIndex: number, offset: number): void {
        (this.getUIComponentHandler() as HomeComponentHandler)
            .loadMoreFeaturedCategoryTones(featuredCategory, startIndex, offset);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/home/homeview.tsx